import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

interface ReCaptchaProps {
  onChange?: (token: string | null) => void;
}

const ReCaptcha = ({ onChange }: ReCaptchaProps) => {
  return (
    <div>
      <ReCAPTCHA
        sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITEKEY as string}
        onChange={onChange}
      />
    </div>
  );
};

export default ReCaptcha;
